import React from "react";
import { Card } from "react-bootstrap";
import { KTIcon } from "../../../_metronic/helpers";
import "./PurchaseDumpLocation.css";

const DUMP_LOCATIONS = [
    {
        value: "QUARRY_TO_STOCKYARD",
        from: "Quarry",
        to: "Stock Yard",
        icon: "package",
        accent: "#E67E22",
        avatarBg: "#EBF5FB",
        iconColor: "#1B84FF",
    },
    {
        value: "QUARRY_TO_CRUSHER",
        from: "Quarry",
        to: "Crusher",
        icon: "gear",
        accent: "#E74C3C",
        avatarBg: "#E1ECFF",
        iconColor: "#0D6EFD",
    },
    {
        value: "STOCKYARD_TO_CRUSHER",
        from: "Stock Yard",
        to: "Crusher",
        icon: "truck",
        accent: "#2E86C1",
        avatarBg: "#DBEAFE",
        iconColor: "#2563EB",
    },
];

export function PurchaseDumpLocationCards({ value, onChange, readOnly = false }) {
    return (
        <Card className="mb-3 border-0 shadow-sm" style={{ borderRadius: "8px" }}>
            <Card.Header className="py-2 px-4" style={{ borderRadius: "8px 8px 0 0", backgroundColor: "#e8f4fc", minHeight: "42px" }}>
                <div className="d-flex align-items-center">
                    <KTIcon iconName="geolocation" className="fs-4 me-2 text-primary" />
                    <span className="fw-semibold small" style={{ color: "#4a90a4" }}>DUMP AT</span>
                </div>
            </Card.Header>
            <Card.Body className="p-3">
                <div className="dump-cards-row">
                    {DUMP_LOCATIONS.map((loc) => {
                        const isSelected = value === loc.value;
                        return (
                            <div
                                key={loc.value}
                                className={`dump-card ${isSelected ? "selected" : ""} ${readOnly ? "read-only" : ""}`}
                                style={{
                                    borderColor: isSelected ? loc.accent : undefined,
                                    '--accent': loc.accent,
                                }}
                                onClick={() => !readOnly && !isSelected && onChange(loc.value)}
                            >
                                <div style={{ backgroundColor: loc.accent }} className="card-check">
                                    <i className="bi bi-check2 text-white" style={{ fontSize: "0.75rem" }} />
                                </div>
                                <div
                                    className="dump-card-avatar"
                                    style={{ background: loc.avatarBg, color: loc.iconColor }}
                                >
                                    <KTIcon iconName={loc.icon} iconType="duotone" />
                                </div>
                                <div className="dump-card-text">
                                    <div className="dump-card-from">{loc.from}</div>
                                    <div className="dump-card-arrow">
                                        <i className="bi bi-arrow-down-short" /> TO
                                    </div>
                                    <div className="dump-card-to" style={{ color: loc.accent }}>
                                        {loc.to}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </Card.Body>
        </Card>
    );
}
